import { Box, useTheme } from "@mui/material";
import GenericAccordion from "@/modules/common/components/ui-kit/generic-accordion";
import TitleWithChildren from "@/modules/lead-page/new/components/sidebar/sections/title-with-children";
import { LeadHistory } from "@/modules/lead-page/new/components/sidebar/fields";
import { useContext } from "react";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import LoadingSkeleton from "@/modules/common/components/ui/loadingSkeleton";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";

const CustomerInformationSection = ({
  fields,
  showHistory = true,
}: {
  fields: {
    title: string;
    field: React.ReactNode;
    titleAction?: React.ReactNode;
    icon?: React.ReactNode;
  }[];
  showHistory?: boolean;
}) => {
  const theme = useTheme();

  return (
    <GenericAccordion
      title="Information"
      id="customer-info"
      defaultExpanded={true}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: theme.nawy.spacing.md,
        }}
      >
        {fields.map((field) => (
          <TitleWithChildren
            key={field.title}
            title={field.title}
            titleAction={field.titleAction}
            icon={field.icon}
          >
            {field.field}
          </TitleWithChildren>
        ))}

        {showHistory ? <LeadHistorySection /> : null}
      </Box>
    </GenericAccordion>
  );
};

const LeadHistorySection = () => {
  const { lead } = useContext(LeadPageContext);

  const leadData = lead?.data?.lead;

  return (
    <PermissionGuard
      permissions={[
        {
          name: PermissionsEnum.JOURNEY_HISTORY,
          level: PermissionLevel.READ,
        },
      ]}
    >
      {leadData ? (
        <LeadHistory />
      ) : (
        <LoadingSkeleton
          columns={1}
          rows={1}
          widths={["4vw"]}
          heights={["2vh"]}
          borderRadius={[2]}
          variants={["rectangular"]}
        />
      )}
    </PermissionGuard>
  );
};

export default CustomerInformationSection;
